import { render, staticRenderFns } from "./TeamViewer.vue?vue&type=template&id=0c60713b&scoped=true&"
import script from "./TeamViewer.vue?vue&type=script&lang=js&"
export * from "./TeamViewer.vue?vue&type=script&lang=js&"
import style0 from "./TeamViewer.vue?vue&type=style&index=0&id=0c60713b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60713b",
  null
  
)

export default component.exports